const REGISTER_PATH_PREFIX = '/register/'

const PREVIOUS_REGISTRATION_PATHS: Record<string, string> = {
  '/register/country': '/register/consent',
  '/register/identity': '/register/country',
  '/register/biometric': '/register/identity',
  '/register/permissions': '/register/biometric',
  '/register/otp': '/register/identity',
  '/register/otp/code': '/register/otp',
  '/register/password': '/register/otp/code',
}

export function getPreviousRegistrationPath(pathname: string): string | null {
  if (!pathname.startsWith(REGISTER_PATH_PREFIX)) return null
  return PREVIOUS_REGISTRATION_PATHS[pathname] ?? null
}
